module.exports = {"140925100":"凤凰镇","140925101":"阳方口镇","140925102":"东寨镇","140925103":"石家庄镇","140925200":"薛家洼乡","140925201":"余庄乡","140925202":"涔山乡","140925203":"化北屯乡","140925204":"西马坊乡","140925205":"新堡乡","140925206":"迭台寺乡","140925207":"圪廖乡","140925208":"怀道乡","140925209":"东马坊乡","140925400":"阳方口煤矿生活区","140925401":"城区居民"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140925.json
// module id = 351
// module chunks = 0